import { SPECIAL_BUILDINGS } from "@dein-go-city/shared";
import { renderBuildingPreview } from "../graphics/BuildingAtlas";
import { applyPanel } from "./UiPanel";
import { PARCHMENT, LAYERS, BUILDING_PANEL, DANGER } from "./theme";
import { playUiClick } from "../audio/sfx";
import { createModal } from "./Modal";
let menuDom = null;
let bannerDom = null;
let bannerCancelCb = null;
let bannerEscapeListener = null;
let toastDom = null;
let toastHideTimer = null;
function getMenuDom() {
    if (menuDom)
        return menuDom;
    const overlay = document.createElement("div");
    overlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: ${LAYERS.buildMenuBackdrop};
    background: rgba(0,0,0,0.55);
    display: none;
  `;
    overlay.addEventListener("click", () => hideMenu());
    // The panel itself never scrolls — its max-height just caps the box, and applyPanel's
    // nine-patch background is sized to that whole box. Only `catalog` (below) scrolls, so the
    // header always renders directly on the panel's own background instead of needing an opaque
    // sticky-header color that would paper over the panel's border artwork.
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.buildMenuPanel};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 340px;
    max-height: 80vh;
    flex-direction: column;
    font-family: ui-sans-serif, system-ui, sans-serif;
    box-shadow: 0 16px 56px rgba(0,0,0,0.55);
    display: none;
  `;
    applyPanel(panel, "beigeLight");
    const header = document.createElement("div");
    header.style.cssText = `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px 9px;
    border-bottom: 1px solid ${PARCHMENT.divider};
    flex-shrink: 0;
  `;
    const titleEl = document.createElement("span");
    titleEl.style.cssText = `
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${PARCHMENT.text};
  `;
    titleEl.textContent = "Gebäude bauen";
    const closeBtn = document.createElement("button");
    closeBtn.style.cssText = `
    background: none;
    border: none;
    color: ${PARCHMENT.textMuted};
    font-size: 20px;
    line-height: 1;
    padding: 0 2px;
  `;
    closeBtn.textContent = "×";
    closeBtn.addEventListener("click", () => {
        playUiClick();
        hideMenu();
    });
    header.append(titleEl, closeBtn);
    const catalog = document.createElement("div");
    catalog.style.cssText =
        "padding: 8px 0 6px; overflow-y: auto; flex: 1; min-height: 0;";
    panel.append(header, catalog);
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    const modal = createModal({ panel, labelledBy: titleEl });
    menuDom = { panel, overlay, catalog, modal };
    return menuDom;
}
function getBannerDom() {
    if (bannerDom)
        return bannerDom;
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.placementBanner};
    bottom: 0;
    left: 0;
    right: 0;
    background: ${BUILDING_PANEL.background};
    border-top: 1px solid ${BUILDING_PANEL.border};
    box-shadow: 0 -4px 24px rgba(0,0,0,0.6);
    padding: 12px 16px;
    display: none;
    flex-direction: column;
    gap: 6px;
    font-family: ui-sans-serif, system-ui, sans-serif;
  `;
    const row = document.createElement("div");
    row.style.cssText = "display: flex; align-items: center; gap: 12px;";
    const label = document.createElement("span");
    label.style.cssText = `font-size: 13px; color: ${BUILDING_PANEL.title}; flex: 1;`;
    const cancelBtn = document.createElement("button");
    cancelBtn.textContent = "Abbrechen";
    cancelBtn.style.cssText = `
    padding: 4px 12px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid rgba(200, 168, 130, 0.3);
    background: rgba(200, 168, 130, 0.08);
    color: ${BUILDING_PANEL.accent};
    white-space: nowrap;
  `;
    cancelBtn.addEventListener("click", () => {
        playUiClick();
        bannerCancelCb?.();
    });
    row.append(label, cancelBtn);
    panel.append(row);
    document.body.appendChild(panel);
    bannerDom = { panel, label };
    return bannerDom;
}
const TOAST_DURATION_MS = 2400;
// Reused across all placement-error toasts; content and position are overwritten per call.
function getToastDom() {
    if (toastDom)
        return toastDom;
    const el = document.createElement("div");
    el.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.placementToast};
    transform: translate(-50%, calc(-100% - 10px));
    background: ${BUILDING_PANEL.background};
    border: 1px solid rgba(224, 112, 112, 0.55);
    border-radius: 6px;
    box-shadow: 0 6px 24px rgba(0,0,0,0.6);
    padding: 6px 12px;
    font-family: ui-sans-serif, system-ui, sans-serif;
    font-size: 12px;
    color: #e07070;
    white-space: nowrap;
    pointer-events: none;
    display: none;
  `;
    document.body.appendChild(el);
    toastDom = { el };
    return toastDom;
}
function hideMenu() {
    if (menuDom) {
        menuDom.panel.style.display = "none";
        menuDom.overlay.style.display = "none";
        menuDom.modal.close();
    }
}
export function showBuildMenu(state, currentUserId, onSelect) {
    const d = getMenuDom();
    const own = state.resources.find((r) => r.userId === currentUserId);
    const ownWood = own?.wood ?? 0;
    const ownSteel = own?.steel ?? 0;
    const ownManpower = own?.manpower ?? 0;
    const builtUnique = new Set(state.buildings
        .filter((b) => b.kind === "special")
        .map((b) => b.specialType));
    // Rebuild catalog from current state each time the menu opens
    d.catalog.textContent = "";
    for (const def of Object.values(SPECIAL_BUILDINGS)) {
        const isBuilt = def.unique && builtUnique.has(def.type);
        const shortWood = ownWood < def.cost.wood;
        const shortSteel = ownSteel < def.cost.steel;
        const shortManpower = ownManpower < def.cost.manpower;
        const canAfford = !shortWood && !shortSteel && !shortManpower;
        const disabled = isBuilt || !canAfford;
        // Card: image on the left, info on the right
        const card = document.createElement("div");
        card.style.cssText = `
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 12px 14px;
      border-bottom: 1px solid ${PARCHMENT.divider};
      opacity: ${disabled ? "0.65" : "1"};
    `;
        // Sprite preview — 64×55 canvas displayed at 2× via CSS
        const preview = renderBuildingPreview(def.type);
        preview.style.cssText = `
      width: 128px;
      height: 110px;
      image-rendering: pixelated;
      flex-shrink: 0;
      align-self: center;
    `;
        card.appendChild(preview);
        // Info column
        const info = document.createElement("div");
        info.style.cssText =
            "display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0;";
        const nameEl = document.createElement("div");
        nameEl.style.cssText = `
      font-size: 13px;
      font-weight: 600;
      color: ${disabled ? PARCHMENT.textMuted : PARCHMENT.text};
      line-height: 1.2;
    `;
        nameEl.textContent = def.name;
        if (def.unique) {
            const badge = document.createElement("span");
            badge.style.cssText = `
        margin-left: 5px;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: ${PARCHMENT.accent};
        background: rgba(138,90,32,0.12);
        border: 1px solid rgba(138,90,32,0.3);
        border-radius: 3px;
        padding: 1px 4px;
        vertical-align: middle;
      `;
            badge.textContent = "Einmalig";
            nameEl.appendChild(badge);
        }
        const descEl = document.createElement("div");
        descEl.style.cssText = `
      font-size: 11px;
      color: ${PARCHMENT.textMuted};
      line-height: 1.35;
    `;
        descEl.textContent = def.description;
        // Cost chips — highlighted in red when the player is short on that resource
        const costsEl = document.createElement("div");
        costsEl.style.cssText =
            "display: flex; flex-wrap: wrap; gap: 4px; margin-top: 2px;";
        function makeChip(label, amount, short) {
            if (amount === 0)
                return;
            const chip = document.createElement("span");
            chip.style.cssText = `
        font-size: 10px;
        font-weight: 600;
        padding: 1px 5px;
        border-radius: 3px;
        border: 1px solid ${short ? "rgba(180,50,50,0.4)" : PARCHMENT.divider};
        background: ${short ? "rgba(180,50,50,0.10)" : "rgba(74,53,36,0.05)"};
        color: ${short ? DANGER : PARCHMENT.textMuted};
      `;
            chip.textContent = `${label} ${amount}`;
            costsEl.appendChild(chip);
        }
        makeChip("Holz", def.cost.wood, shortWood);
        makeChip("Stahl", def.cost.steel, shortSteel);
        makeChip("Arbeit", def.cost.manpower, shortManpower);
        // Action button
        const btn = document.createElement("button");
        btn.style.cssText = `
      margin-top: 4px;
      padding: 4px 12px;
      font-size: 11px;
      font-weight: 600;
      border-radius: 4px;
      border: 1px solid ${disabled ? PARCHMENT.divider : PARCHMENT.highlightBorder};
      background: ${disabled ? "transparent" : PARCHMENT.highlightBg};
      color: ${disabled ? PARCHMENT.textMuted : PARCHMENT.text};
      align-self: flex-start;
    `;
        btn.disabled = disabled;
        if (isBuilt) {
            btn.textContent = "Bereits gebaut";
        }
        else if (!canAfford) {
            btn.textContent = "Zu wenig Ressourcen";
        }
        else {
            btn.textContent = "Errichten";
            btn.addEventListener("click", () => {
                playUiClick();
                hideMenu();
                onSelect(def.type);
            });
        }
        info.append(nameEl, descEl, costsEl, btn);
        card.appendChild(info);
        d.catalog.appendChild(card);
    }
    d.overlay.style.display = "block";
    d.panel.style.display = "flex";
    d.modal.open(hideMenu);
}
export function showPlacementBanner(buildingName, onCancel, hint) {
    bannerCancelCb = onCancel;
    const d = getBannerDom();
    d.label.textContent = hint ?? `Tippe auf ein freies Feld für: ${buildingName}`;
    d.panel.style.display = "flex";
    if (bannerEscapeListener)
        document.removeEventListener("keydown", bannerEscapeListener);
    bannerEscapeListener = (e) => {
        if (e.key === "Escape")
            bannerCancelCb?.();
    };
    document.addEventListener("keydown", bannerEscapeListener);
}
export function hidePlacementBanner() {
    if (bannerDom) {
        bannerDom.panel.style.display = "none";
    }
    bannerCancelCb = null;
    if (bannerEscapeListener) {
        document.removeEventListener("keydown", bannerEscapeListener);
        bannerEscapeListener = null;
    }
}
// Temporary toast anchored at the screen position of the tile the player tried to build on
// (x, y in Excalibur screen space — same space as PointerEvent.screenPos). Auto-hides after
// TOAST_DURATION_MS; a new call before that resets the timer.
export function showPlacementErrorToast(x, y, msg) {
    const d = getToastDom();
    d.el.textContent = msg;
    d.el.style.left = `${x}px`;
    d.el.style.top = `${y}px`;
    d.el.style.display = "block";
    if (toastHideTimer)
        clearTimeout(toastHideTimer);
    toastHideTimer = setTimeout(() => {
        d.el.style.display = "none";
        toastHideTimer = null;
    }, TOAST_DURATION_MS);
}
